import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGlynt from '../../hooks/useGlynt';
import { IRulesetListParams } from '../../../types/ruleset-types';

export function useRulesets(
  dataPoolId: string,
  params?: IRulesetListParams,
  enabled: boolean = true
) {
  const glynt = useGlynt();

  return useQuery({
    queryKey: ['rulesets', dataPoolId, params],
    queryFn: async () => (await glynt).ruleset.list(dataPoolId, params),
    enabled,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
}
